._suggestion_12aj5_1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  gap: 6px; }
  ._suggestion__moreButton_12aj5_7 {
    padding-left: 6px; }
